import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';

export const brandActions = createDataFetchActions(
    '@BRANDS',
    ({ apiService }) => () => apiService.shopApi.getBrands(),
    () => '@BRANDS'
);

export type BrandActionType = ActionType<typeof brandActions.actions>;

export default brandActions.thunk;
